import "./style.scss";

import { ButtonIconPosition, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, Row, Spacer } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import { Button } from "@amzn/stencil-react-components/button";
import IconExternalLink from "@amzn/stencil-react-icons/icons/icon-external-link";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";

interface HardwareSupportOptionsProps {
  onOrderClick: () => void;
}

export const HardwareSupportOptions: FC<HardwareSupportOptionsProps> = ({ onOrderClick }) => {
  return (
    <Col gridGap="S600">
      <Row className="flyout-row">
        <Col className="flyout-text">
          <Text fontSize="T300" fontWeight="bold">{getString("hardwareSupport.orderTitle")}</Text>
          <Spacer height="S200" />
          <Text fontSize="T200">{getString("hardwareSupport.orderDescription")}</Text>
          <Spacer height="S300" />
          <Button className="flyout-button" variant={ButtonVariant.Secondary} onClick={onOrderClick}>
            {getString("hardwareSupport.orderButton")}
          </Button>
        </Col>
        <img className="flyout-image" src="/img/hardwareSupportCheckList.svg" alt="" />
      </Row>

      <Row className="flyout-row">
        <Col className="flyout-text">
          <Text fontSize="T300" fontWeight="bold">{getString("hardwareSupport.shipmentTitle")}</Text>
          <Spacer height="S200" />
          <Text fontSize="T200">{getString("hardwareSupport.shipmentDescription")}</Text>
          <Spacer height="S300" />
          <Link href={getString("externalLinks.hardwareTicketUrl")} target="_blank">
            <Button
              className="flyout-button"
              variant={ButtonVariant.Secondary}
              icon={<IconExternalLink aria-hidden={true} />}
              iconPosition={ButtonIconPosition.Trailing}
            >
              {getString("hardwareSupport.shipmentButton")}
            </Button>
          </Link>
        </Col>
        <img className="flyout-image" src="/img/hardwareSupportBox.svg" alt="" />
      </Row>

      <Row className="flyout-row">
        <Col className="flyout-text">
          <Text fontSize="T300" fontWeight="bold">{getString("hardwareSupport.technicalTitle")}</Text>
          <Spacer height="S200" />
          <Text fontSize="T200">{getString("hardwareSupport.technicalDescription")}</Text>
          <Spacer height="S300" />
          <Link href={getString("externalLinks.technicalSupportUrl")} target="_blank">
            <Button
              className="flyout-button"
              variant={ButtonVariant.Secondary}
              icon={<IconExternalLink aria-hidden={true} />}
              iconPosition={ButtonIconPosition.Trailing}
            >
              {getString("hardwareSupport.technicalButton")}
            </Button>
          </Link>
        </Col>
        <img className="flyout-image" src="/img/hardwareSupportGears.svg" alt="" />
      </Row>
    </Col>
  );
};
